import React, { useState, useEffect } from 'react';

import axios from 'axios';

function AddNewSupplier() {
    const [formData, setFormData] = useState({
        classified_id: '',
        supplier_name: '',
        providers_of: '',
        contact_person: '',
        address: '',
        state: '',
        district: '',
        tehsil: '',
        city: '',
        pincode: '',
        mobile_no: '',
        phone_no: '',
        email: '',
        website: '',
        isActive: false
    });

    const [errors, setErrors] = useState({});
    const [successMessage, setSuccessMessage] = useState('');
    const [submitError, setSubmitError] = useState('');
    const [classifiedList, setClassifiedList] = useState([]);


    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const validate = () => {
        let tempErrors = {};
        let isValid = true;

        if (!formData.classified_id) {
            tempErrors.classified_id = 'Please select classified.';
            isValid = false;
        }
        if (!formData.supplier_name) {
            tempErrors.supplier_name = 'Please enter supplier name.';
            isValid = false;
        }
        if (!formData.pincode || !/^\d{6}$/.test(formData.pincode)) {
            tempErrors.pincode = 'Please enter a valid 6-digit pin code.';
            isValid = false;
        }
        if (formData.mobile_no && !/^\d{10}$/.test(formData.mobile_no)) {
            tempErrors.mobile_no = 'Mobile number must be 10 digits.';
            isValid = false;
        }
        if (formData.phone_no && !/^\d{6,15}$/.test(formData.phone_no)) {
            tempErrors.phone_no = 'Phone number must be 6 to 15 digits.';
            isValid = false;
        }
        if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
            tempErrors.email = 'Invalid email format.';
            isValid = false;
        }

        setErrors(tempErrors);
        return isValid;
    };


useEffect(() => {
    const fetchClassifieds = async () => {
        try {
            const response = await axios.get("https://backend-zkgn.onrender.com/api/classified");
            setClassifiedList(response.data); // Make sure this returns an array of objects like { id, classified_name }
        } catch (error) {
            console.error("Error fetching classifieds:", error);
        }
    };

    fetchClassifieds();
}, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validate()) {
            try {
                const response = await axios.post("https://backend-zkgn.onrender.com/api/suppliers", formData);

                if (response.status === 201 || response.status === 200) {
                    setSuccessMessage('Supplier added successfully!');
                    setSubmitError('');
                    setFormData({
                        classified_id: '',
                        supplier_name: '',
                        providers_of: '',
                        contact_person: '',
                        address: '',
                        state: '',
                        district: '',
                        tehsil: '',
                        city: '',
                        pincode: '',
                        mobile_no: '',
                        phone_no: '',
                        email: '',
                        website: '',
                        isActive: false
                    });

                    setTimeout(() => setSuccessMessage(''), 3000);
                } else {
                    setSubmitError('Something went wrong. Please try again.');
                }
            } catch (error) {
                console.error(error);
                setSubmitError('Error connecting to the server.');
            }
        }
    };

    return (
        <div className="container my-5">
            <h2 className="text-center mb-4">Add New Supplier</h2>

            {successMessage && <div className="alert alert-success">{successMessage}</div>}
            {submitError && <div className="alert alert-danger">{submitError}</div>}

            <form onSubmit={handleSubmit} className="shadow p-4 bg-light rounded">
                <div className="row g-3">

                    <div className="col-md-6">
                        <label className="form-label">Classified</label>
                        <select
                            className="form-select"
                            name="classified_id"
                            value={formData.classified_id}
                            onChange={handleChange}
                        >
                            <option value="">Select Classified</option>
                            {classifiedList.map((c) => (
                               <option key={c.classified_id} value={c.classified_id}>
                                {c.classified_name}
                                </option>

                            ))}
                        </select>
                        {errors.classified_id && <small className="text-danger">{errors.classified_id}</small>}
                    </div>


                    <div className="col-md-6">
                        <label className="form-label">Supplier Name</label>
                        <input
                            type="text"
                            className="form-control"
                            name="supplier_name"
                            value={formData.supplier_name}
                            onChange={handleChange}
                        />
                        {errors.supplier_name && <small className="text-danger">{errors.supplier_name}</small>}
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Providers Of</label>
                        <textarea
                            className="form-control"
                            name="providers_of"
                            value={formData.providers_of}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-6">
                        <label className="form-label">Contact Person</label>
                        <input
                            type="text"
                            className="form-control"
                            name="contact_person"
                            value={formData.contact_person}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-12">
                        <label className="form-label">Address</label>
                        <textarea
                            className="form-control"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">State</label>
                        <input
                            type="text"
                            className="form-control"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">District</label>
                        <input
                            type="text"
                            className="form-control"
                            name="district"
                            value={formData.district}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Tehsil</label>
                        <input
                            type="text"
                            className="form-control"
                            name="tehsil"
                            value={formData.tehsil}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">City</label>
                        <input
                            type="text"
                            className="form-control"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Pincode</label>
                        <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleChange}
                        />
                        {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Mobile No</label>
                        <input
                            type="text"
                            className="form-control"
                            name="mobile_no"
                            value={formData.mobile_no}
                            onChange={handleChange}
                        />
                        {errors.mobile_no && <small className="text-danger">{errors.mobile_no}</small>}
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Phone No</label>
                        <input
                            type="text"
                            className="form-control"
                            name="phone_no"
                            value={formData.phone_no}
                            onChange={handleChange}
                        />
                        {errors.phone_no && <small className="text-danger">{errors.phone_no}</small>}
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                        />
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                    </div>

                    <div className="col-md-4">
                        <label className="form-label">Website</label>
                        <input
                            type="text"
                            className="form-control"
                            name="website"
                            value={formData.website}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="col-md-12 d-flex align-items-center">
                        <input
                            type="checkbox"
                            className="form-check-input me-2"
                            name="isActive"
                            checked={formData.isActive}
                            onChange={handleChange}
                        />
                        <label className="form-check-label">Active Supplier?</label>
                    </div>
                </div>

                <div className="text-center mt-4">
                    <button type="submit" className="btn btn-primary px-4">Submit</button>
                </div>
            </form>
        </div>
    );
}

export default AddNewSupplier;
